<template>
  <li :class="{'active-filter':active}" @click="featureItemClicked"><slot name="featureContent"></slot></li>
</template>

<script>
  export default {
    name: 'featureItem',
    data () {
      return {
        active: false
      }
    },
    methods: {
      toggleSelected: function () {
        if (this.active === true) {
          this.active = false
        } else {
          this.active = true
        }
      },
      featureItemClicked: function () {
        this.$emit('updateRemoteFilter')
        this.toggleSelected()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// featureItem.vue?362ceaab